
// $('.slider__img').slick({
//     infinite: true,
//     slidesToShow: 1,
//     slidesToScroll: 1
//   });

  $('.slider__img').slick();